import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import logo from "../Assets/Kalam Kids Logo_newlogo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';

const DownloadPage = () => {
  const location = useLocation();
  const [bill, setBill] = useState(location.state?.bill || null);

  useEffect(() => {
    if (!bill) {
      const storedBill = localStorage.getItem("downloadBill");
      if (storedBill) {
        setBill(JSON.parse(storedBill));
      }
    }
  }, [bill]);

  const handlePrint = () => {
    window.print();
  };

  if (!bill) {
    return <div className="text-center mt-10">Loading...</div>;
  }

  return (
    <div className="bg-gray-100 min-h-screen p-8 print:bg-white font-poppins">
      <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-lg p-8" id="printable-content">
        <header className="flex justify-between items-center pb-4 border-b">
          <img src={logo} alt="logo" className="w-40" />
          <h1 className="text-2xl font-bold text-gray-800">Payment Receipt</h1>
        </header>

        <section className="grid grid-cols-2 gap-8 mt-8">
          <div>
            <h2 className="text-lg font-semibold text-gray-700 mb-4">Billed To</h2>
            <div className="space-y-2 text-gray-800">
              <p><span className="font-medium">Received From:</span> {bill.cashReceivedFrom}</p>
              <p><span className="font-medium">Relationship:</span> {bill.relationshipName}</p>
              <p><span className="font-medium">Student Name:</span> {bill.fullName}</p>
              <p><span className="font-medium">Admission No:</span> {bill.registerNo}</p>
              <p><span className="font-medium">Class:</span> {bill.class}</p>
            </div>
          </div>
          <div className="text-right">
            <h2 className="text-lg font-semibold text-gray-700 mb-4">Payment Details</h2>
            <div className="space-y-2 text-gray-800">
              <p><span className="font-medium">Payment ID:</span> {bill.paymentId}</p>
              <p><span className="font-medium">Date:</span> {bill.date?.slice(0, 10).split("-").reverse().join("-")}</p>
              <p><span className="font-medium">Payment Mode:</span> {bill.paidBy}</p>
            </div>
          </div>
        </section>

        <section className="mt-8">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr>
                <th className="border-b-2 p-3 font-medium text-gray-700">Description</th>
                <th className="border-b-2 p-3 font-medium text-gray-700 text-right">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="p-3 text-gray-800">Fee Payment</td>
                <td className="p-3 text-right text-gray-800">₹{bill.amount}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td className="p-3 font-medium text-right text-gray-800">Total Paid</td>
                <td className="p-3 font-medium text-right text-gray-800">₹{bill.amount}</td>
              </tr>
              <tr>
                <td className="p-3 text-right text-gray-800">Remaining Balance</td>
                <td className="p-3 text-right text-gray-800">₹{bill.remaining}</td>
              </tr>
            </tfoot>
          </table>
          <div className="mt-4 p-3 bg-gray-50 rounded-md text-gray-800">
            <p className="font-medium">Amount in words:</p>
            <p className="capitalize">{bill.amountInWords} rupees only</p>
          </div>
        </section>

        <footer className="flex justify-between items-center mt-8 pt-4 border-t text-gray-700">
          <div>
            <p className="font-medium">Receiver: {bill.receiverName}</p>
          </div>
          <div className="text-sm text-gray-600">
            <p>www.kalamkids.in</p>
            <p>#23, New Shankaranpalayam Road, Near Tollgate, Vellore - 632 001. TN.</p>
          </div>
        </footer>
      </div>

      <div className="text-center mt-8 print:hidden">
        <button
          onClick={handlePrint}
          className="bg-[#16bab1] text-white px-6 py-2 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
        >
          <FontAwesomeIcon icon={faPrint} className="mr-2" />
          Print Receipt
        </button>
      </div>

      <style jsx>{`
        @media print {
          body {
            background-color: #fff;
          }
          .print\\:hidden {
            display: none;
          }
          #printable-content {
            box-shadow: none;
            margin: 0;
            max-width: 100%;
            border: none;
          }
        }
      `}</style>
    </div>
  );
};

export default DownloadPage;
